<div class="modal fade show d-block" tabindex="-1" role="dialog" (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content rounded-4 shadow border-0">
      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title d-flex align-items-center gap-2">
          <span class="material-symbols-outlined text-colonial">{{ isRegionsOnly ? 'map' : 'person_add' }}</span>
          {{ isRegionsOnly ? 'Editar regiones' : 'Invitar usuario' }}
        </h5>
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="onCancel()"></button>
      </div>

      <div class="modal-body">
        <ng-container *ngIf="isRegionsOnly; else inviteForm">
          <p class="text-muted small mb-2">
            Regiones de {{ editingRegionsFor!.name }} {{ editingRegionsFor!.lastName }}
          </p>
        </ng-container>

        <ng-template #inviteForm>
          <form [formGroup]="form" class="row g-3">
            <div class="col-12">
              <label class="form-label small" for="inviteEmail">Correo electrónico</label>
              <input id="inviteEmail" type="email" class="form-control" formControlName="email"
                placeholder="usuario@banco.do" />
              <p class="text-muted small mb-0 mt-1">El usuario obtendrá acceso al iniciar sesión con este correo.</p>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label small" for="inviteName">Nombre</label>
              <input id="inviteName" type="text" class="form-control" formControlName="name" />
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label small" for="inviteLastName">Apellido</label>
              <input id="inviteLastName" type="text" class="form-control" formControlName="lastName" />
            </div>
            <div class="col-12 col-md-6" *ngIf="isSuperUser">
              <label class="form-label small" for="inviteBank">Banco</label>
              <select id="inviteBank" class="form-select" formControlName="bankId">
                <option [ngValue]="null" disabled>Seleccione...</option>
                <option *ngFor="let b of banks" [ngValue]="b.id">{{ b.name }}</option>
              </select>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label small" for="inviteRole">Rol</label>
              <select id="inviteRole" class="form-select" formControlName="role">
                <option value="Global">Global</option>
                <option value="Regional" *ngIf="!isSuperUser">Regional</option>
              </select>
              <p class="text-muted small mb-0 mt-1" *ngIf="isSuperUser">
                Los usuarios regionales los invita el usuario global de cada banco.
              </p>
            </div>
          </form>
        </ng-template>

        <div *ngIf="needsRegions" class="mt-3">
          <label class="form-label small">Regiones</label>
          <p *ngIf="!loadingRegions && regions.length === 0" class="text-muted small">
            Este banco no tiene regiones. Créalas primero desde la pantalla del banco.
          </p>
          <div class="form-check" *ngFor="let region of regions">
            <input class="form-check-input" type="checkbox" [id]="'region-' + region.id"
              [checked]="selectedRegionIds.has(region.id)" (change)="onRegionToggled(region.id, $event)" />
            <label class="form-check-label" [for]="'region-' + region.id">
              {{ region.name }}
              <span class="text-muted small">({{ region.branchCount }} sucursales)</span>
            </label>
          </div>
        </div>
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>
        <button type="button" class="btn bg-colonial btn-secondary" (click)="onSave()"
          [disabled]="!canSave">{{ isRegionsOnly ? 'Guardar' : 'Invitar' }}</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show"></div>
